import { render, staticRenderFns } from "./SkillFeedbackResponseDetail.vue?vue&type=template&id=6149e242&"
import script from "./SkillFeedbackResponseDetail.vue?vue&type=script&lang=js&"
export * from "./SkillFeedbackResponseDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports